import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class CostharegionEditService {

	private apiUrl = globalConst.baseAPI;  // URL para web api

	/**
	* Método construtor
	* @param http: Http
	*/
	constructor(private http: Http) { }

	// Listar listUser
	getCost(token, idCost) {

		return this.http
		.get(this.apiUrl + "costharegion/v1/getcodcostharegion/" + idCost, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}


	// Salvar Edição do Usuário
	editCost(token, editCost: any){

		return this.http
		.put(this.apiUrl + "costharegion/v1/updatecostharegion", editCost, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/costharegion/service/costharegion-edit/costharegion-edit.service.ts